import { Injectable } from '@angular/core';

export type AppLang = 'en' | 'id';

export const SUPPORTED_LANGS: AppLang[] = ['en', 'id'];
export const DEFAULT_LANG: AppLang = 'en';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private currentLang: AppLang = DEFAULT_LANG;

  isSupported(lang: string): lang is AppLang {
    return SUPPORTED_LANGS.includes(lang as AppLang);
  }

  getLang(): AppLang {
    return this.currentLang;
  }

  setLang(lang: string): void {
    this.currentLang = this.isSupported(lang) ? lang : DEFAULT_LANG;
  }
}
